export default {"src":"/_next/static/media/summary-icon-close.afd33832.svg","height":800,"width":800};